export default "__VITE_ASSET__Byh3MSVf__"